export const formatDate = (date: string) => {
    const dateParts = date.split('-');

    // format YYYY-mm-dd
    return dateParts.length === 3
        ? `${dateParts[0]}-${dateParts[1].padStart(2, '0')}-${dateParts[2].padStart(2, '0')}`
        : date;
};
